import React from 'react';

import * as Styled from './Counter.styles';
import useGlobalStore from 'utils/store';

import Countdown from 'react-countdown';

export interface CounterProps {}

const Counter: React.FC<CounterProps> = () => {
  const { copy, hasAllFeatures } = useGlobalStore();

  const formatNumber = (val: number) => {
    return val < 10 ? `0${val}` : val;
  }

  const renderer = ({ days, hours, minutes, seconds, completed }: {days: number, hours: number, minutes: number, seconds: number, completed: boolean}) => {
    if (completed) {
      // Render a completed state
      // return ;
    } else {
      // Render a countdown
      return (
        <>        
          <Styled.Block>
            <Styled.Number>{formatNumber(days)}</Styled.Number>
            <Styled.Label>{copy.event.time.days}</Styled.Label>
          </Styled.Block>
          <Styled.Divide>:</Styled.Divide>
          <Styled.Block>
            <Styled.Number>{formatNumber(hours)}</Styled.Number>
            <Styled.Label>{copy.event.time.hours}</Styled.Label>
          </Styled.Block>
          <Styled.Divide>:</Styled.Divide>
          <Styled.Block>
            <Styled.Number>{formatNumber(minutes)}</Styled.Number>
            <Styled.Label>{copy.event.time.minutes}</Styled.Label>
          </Styled.Block>
          <Styled.Divide>:</Styled.Divide>
          <Styled.Block>
            <Styled.Number>{formatNumber(seconds)}</Styled.Number>
            <Styled.Label>{copy.event.time.seconds}</Styled.Label>
          </Styled.Block>
        </>
      );
    }
  };

  return <Styled.Wrapper>
    
    <Countdown
      date={copy.preSale.date}
      renderer={renderer}
    />

  </Styled.Wrapper>;
};

export default Counter;
